import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Subscription } from 'rxjs';


export const compareValidator =
    (controlNameToCompare: string): ValidatorFn =>
        (c: AbstractControl): ValidationErrors | null => {
            if (c.value === null || c.value.length === 0) {
                return null;
            }

            const controlToCompare: AbstractControl = c.root.get(controlNameToCompare);

            if (controlToCompare) {
                const subscription: Subscription =
                    controlToCompare.valueChanges.subscribe(() => {
                        c.updateValueAndValidity();
                        subscription.unsubscribe();
                    });
            }

            return controlToCompare && controlToCompare.value !== c.value
                ? { mismatch: true }
                : null;
        };
